import React from 'react';
import { Link } from 'react-router-dom';
import { reportAPI } from '../../utils/api';

export default function ReportsMainPage() {
  const cards = [
    { title: 'Enrollment Reports', path: '/reports/enrollment' },
    { title: 'Procurement Reports', path: '/reports/procurement' },
  ];
  const exports = [
    ['enrollment', 'Enrollment'],
    ['tenders', 'Tenders'],
    ['work-orders', 'Work Orders'],
    ['delivery-notes', 'Delivery Notes'],
    ['warehouse-receipts', 'Warehouse Receipts'],
    ['qc', 'QC Reports'],
    ['requisitions', 'Warehouse Requisitions'],
    ['handovers', 'Head Master Handovers'],
    ['invoices', 'Invoices'],
    ['events', 'Operational Events'],
    ['minister-summary', 'Minister Summary'],
  ];

  const download = async (type, label) => {
    const res = await reportAPI.exportCsv(type);
    const url = URL.createObjectURL(new Blob([res.data], { type: 'text/csv' }));
    const a = document.createElement('a');
    a.href = url;
    a.download = `${label.toLowerCase().replace(/\s+/g, '_')}_export.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="container">
      <h2>Reports</h2>
      <div style={{ display: 'flex', gap: 24, flexWrap: 'wrap' }}>
        {cards.map(card => (
          <Link key={card.path} to={card.path} style={{ padding: 24, border: '1px solid #ccc', borderRadius: 6, minWidth: 200 }}>
            {card.title}
          </Link>
        ))}
      </div>
      <div style={{ marginTop: 28 }}>
        <h3>Exports</h3>
        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
          {exports.map(([type, label]) => (
            <button key={type} type="button" className="btn btn-outline-secondary btn-sm" onClick={() => download(type, label)}>
              {label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
